import { useEffect, useState } from 'react'
import constant from 'lodash/constant'
import get from 'lodash/get'
import isObject from 'lodash/isObject'
import isString from 'lodash/isString'
import { getBuildSha } from '@klear/runtime-env'

const pendingChecks = new Set<() => void>()

export function requestBuildVersionCheck(): void {
  for (const check of pendingChecks) check()
}

export async function fetchDeployedBuildSha(versionUrl: string): Promise<string> {
  try {
    const response = await fetch(versionUrl, { cache: 'no-store' })
    if (!response.ok) return ''
    const body = await response.json().catch(constant(null))
    const version = isObject(body) ? get(body, 'version') : undefined
    return isString(version) ? version : ''
  } catch {
    return ''
  }
}

export function isBuildStale(buildSha: string, deployedSha: string): boolean {
  if (!buildSha || !deployedSha) return false
  return buildSha !== deployedSha
}

export function useBuildVersionGate(versionUrl = '/version.json') {
  const buildSha = getBuildSha()
  const [isStale, setIsStale] = useState(false)

  useEffect(() => {
    if (!buildSha || isStale) return

    let cancelled = false
    const check = () => {
      void fetchDeployedBuildSha(versionUrl).then((deployedSha) => {
        if (!cancelled && isBuildStale(buildSha, deployedSha)) setIsStale(true)
      })
    }

    check()
    pendingChecks.add(check)

    return () => {
      cancelled = true
      pendingChecks.delete(check)
    }
  }, [buildSha, versionUrl, isStale])

  return { isStale }
}
